import React, { useState, useEffect } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./auth/firebase";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Login from "./components/Login";
import ForgotPassword from "./auth/ForgotPassword";
import Dashboard from "./components/Dashboard";
import EnrolmentForm from "./components/forms/EnrolmentForms/EnrolmentForm";
import "./App.css";
import EnquiryForm from "./components/forms/EnquiryForm";
import LeaveForm from "./components/forms/LeaveForm";
import DomesticEnrolmentForm from "./components/forms/EnrolmentForms/DomesticEnrolmentForm";
import AgentApplicationForm from "./components/forms/AgentForms/AgentApplicationForm";

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser?.email || null);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
  };

  if (loading) return <div>Loading...</div>;

  return (
    <Router>
      <Routes>
        {/* Public route for enrolment */}
        <Route path="/enrolment" element={<EnrolmentForm />} />

        {/* Public route for enrolment */}
        <Route path="/enquire-now" element={<EnquiryForm isPublic={true} />} />

        {/* Public route for enrolment */}
        <Route path="/leave-application" element={<LeaveForm isPublic={true} />} />

        {/* Public route for enrolment */}
        <Route path="/domestic-enrolment" element={<DomesticEnrolmentForm />} />

        {/* Agent Application form */}
        <Route path="/agent-application" element={<AgentApplicationForm/>} />

        {/* Auth routes */}
        {user ? (
          <Route path="/" element={<Dashboard user={user} onLogout={handleLogout} />} />
        ) : showForgotPassword ? (
          <Route path="/" element={<ForgotPassword onBack={() => setShowForgotPassword(false)} />} />
        ) : (
          <Route path="/" element={<Login onForgotPassword={() => setShowForgotPassword(true)} />} />
        )}
      </Routes>
    </Router>
  );
}
